"use strict";
const _ = require("lodash");

export default angular
  .module("UrlCtrl", ["angularUtils.directives.dirPagination", "ui.bootstrap"])
  .controller("UrlController", [
    "$scope",
    "$http",
    "$modal",
    "$filter",
    "$rootScope",
    // "Socket",
    "Flash",
    "Urls",
    function (
      $scope,
      $http,
      $modal,
      $filter,
      $rootScope,
      // Socket,
      Flash,
      Urls
    ) {
      $scope.links = {
        data: []
      };
      const loadLinks = function () {
        $scope.loadingLinks = true;
        Urls.loadUrlTemplates(function (data) {
          $scope.links.data = data
          $scope.loadingLinks = false;
        });
      };

      $scope.sortLinks = {
        column: "ID",
        descending: false
      };
      $scope.currentPage = 1;
      $scope.tablePage = {
        size: { value: 10, name: "10" },
        options: [
          { value: 10, name: "10" },
          { value: 50, name: "50" },
          { value: $scope.links.data.length, name: "Kaikki" }
        ]
      };


      loadLinks();
      // Sets table sort according to COLUMN, toggles between ascending and descending
      $scope.changeSorting = function (column) {
        if ($scope.sortLinks.column == column) {
          $scope.sortLinks.descending = !$scope.sortLinks.descending;
        } else {
          $scope.sortLinks.column = column;
          $scope.sortLinks.descending = false;
        }
      };
    }
  ]);
